var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSebrae = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sebrae",
    width: 80.868,
    height: 38,
    viewBox: "0 0 80.868 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M68.594,4.192,69.509,0H44.4L43.5,4.192Z",
    transform: "translate(-13.485)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M66.627,13.275l.916-4.213H42.473l-.937,4.213Z",
    transform: "translate(-12.875 -2.803)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M36.8,31.136h5.921c.554,0,1-.041,1.448-.062a6.692,6.692,0,0,0,2.3-.475,4.711,4.711,0,0,0,1.917-1.57,3.937,3.937,0,0,0,.724-2.23c0-1.28-.873-2.106-2.662-2.416l.043-.041c2-.475,3.174-1.446,3.536-2.933a3.821,3.821,0,0,0,.064-.661,2.176,2.176,0,0,0-.618-1.59,3.816,3.816,0,0,0-1.938-.909,15.007,15.007,0,0,0-2.492-.124H39.655L37.12,29.607ZM42.765,20.5h2.045a1.66,1.66,0,0,1,1.129.31,1.046,1.046,0,0,1,.256,1.115,1.72,1.72,0,0,1-.98,1.28,4.094,4.094,0,0,1-1.044.165H42.1Zm-1.129,5.184h1.938a5.762,5.762,0,0,1,.618.021c.788.124,1.129.475,1.129,1.095a1.572,1.572,0,0,1-.043.434,1.79,1.79,0,0,1-1.108,1.3A3.224,3.224,0,0,1,43,28.719H40.954Z",
    transform: "translate(-11.388 -5.62)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M8.03,17.648a7.718,7.718,0,0,0-4.6,1.26,4.5,4.5,0,0,0-1.938,2.809,4.2,4.2,0,0,0-.085.847q0,2.014,2.62,2.726l3.11.847c.639.165.937.475.937.909a2.181,2.181,0,0,1-.021.351c-.234.971-1,1.466-2.343,1.466-1.278,0-1.917-.475-1.917-1.4a1.688,1.688,0,0,1,.106-.6H.128A4.513,4.513,0,0,0,0,27.953a3.073,3.073,0,0,0,.511,1.776c.745,1.033,2.279,1.528,4.579,1.528a9.221,9.221,0,0,0,4.452-1.012,4.654,4.654,0,0,0,2.407-3.18,3.112,3.112,0,0,0,.128-.929,2.194,2.194,0,0,0-1.044-1.962,8.566,8.566,0,0,0-2.173-.847L6.5,22.707c-.745-.186-1.108-.537-1.108-1.033a.593.593,0,0,1,.043-.268,1.544,1.544,0,0,1,.682-1.012A2.512,2.512,0,0,1,7.5,20.023c.98,0,1.448.413,1.448,1.177a1.689,1.689,0,0,1-.106.6h3.791a4.874,4.874,0,0,0,.128-1.157C12.78,18.66,11.182,17.648,8.03,17.648Z",
    transform: "translate(0 -5.473)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M29.86,28.614H23.3l.575-2.747h6.07l.554-2.5H24.471l.575-2.705h6.432l.192-.929.362-1.549H21.916l-2.854,12.97H29.306Z",
    transform: "translate(-5.898 -5.638)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M82.427,18.155,74.8,30.236l-.554.909h3.727l1.491-2.623h5.367l.362,2.623h4.217l-2.449-12.99Zm-1.555,7.972,1.853-3.263,1.235-2.189h.021l.554,5.452Z",
    transform: "translate(-22.981 -5.629)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M110.739,20.663l.554-2.478H101.175l-2.854,12.97h10.288l.532-2.54H102.56l.618-2.747h6.049l.575-2.5h-6.07l.618-2.705Z",
    transform: "translate(-30.425 -5.638)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M67.994,23.99a3.515,3.515,0,0,0,1.768-2.416,5.713,5.713,0,0,0,.128-1.012,2.457,2.457,0,0,0-.511-1.528l-.064-.062a2.681,2.681,0,0,0-1.747-.785,16.873,16.873,0,0,0-2.109-.062H59.24l-2.854,12.99h3.727l1.129-5.06H62.8a2.344,2.344,0,0,1,1.108.186.949.949,0,0,0,.106.021,1.087,1.087,0,0,1,.32.847c0,.186-.043.558-.106,1.074a18.436,18.436,0,0,0-.192,2.953h4.047a25.436,25.436,0,0,1,.064-3.222c.043-.537.064-.929.064-1.157a2.133,2.133,0,0,0-.447-1.466,2.811,2.811,0,0,0-1.981-.537l.043-.083A7.6,7.6,0,0,0,67.994,23.99Zm-3.28-.392a2.572,2.572,0,0,1-.809.083,3.9,3.9,0,0,1-.745.041H61.753l.682-3.2H63.9a4.545,4.545,0,0,1,1.427.165.958.958,0,0,1,.746.991,1.073,1.073,0,0,1-.064.434A1.782,1.782,0,0,1,64.714,23.6Z",
    transform: "translate(-17.449 -5.62)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M33.76,48.948l-.895,4.192H57.978l.895-4.192Z",
    transform: "translate(-10.188 -15.141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M35.728,39.916l-.895,4.172H59.9l.937-4.172Z",
    transform: "translate(-10.798 -12.347)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSebrae, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sebrae.c65b5675.svg";
export { ForwardRef as ReactComponent };